<template>
  <div>
    <div class="row">
      <div class="col">
        <strong :class="{magic: item.attack.magic}">
          <a @click="showViewModal = true" v-if="item.description">{{name}}</a>
          <span v-else>{{name}}</span>
          <pf-actions :item="item.actions"></pf-actions>
        </strong>
        <small
          v-if="item.type !== 'Potion'"
          class="form-text text-muted small-left"
        >{{item.damage.type}}</small>
      </div>

      <div class="col-flex text-center" v-if="showToHit">
        <small v-if="item.type !== 'Potion'" class="form-text text-muted small-right">To Hit</small>
        <ez-modal-dice
          class="bold"
          slot="underline"
          :name="item.name"
          :dice="toHitDice"
        >
          {{toHitDisplay}}
        </ez-modal-dice>
      </div>

      <div class="col-flex text-center" v-if="showDamage">
        <small v-if="item.type !== 'Potion'" class="form-text text-muted small-right">Damage</small>
        <ez-modal-dice
          class="bold"
          slot="underline"
          :name="`${item.name} Damage`"
          :dice="`${item.damage.dice}+${damageBonus}`"
        ><!--
          -->{{item.damage.dice}}<!--
          --><span v-if="damageBonus !== 0"><!--
          --><span v-if="damageBonus > -1">+</span>{{damageBonus}}</span>
        </ez-modal-dice>
      </div>

      <div v-if="!showToggle && canEdit" class="col-flex">
        <a :id="`actions-${item._id}`" @click="$emit('setId')" class="cogs125 modal-toggle">
          <i class="fa fa-cog fa-fw"></i>
        </a>
      </div>

      <div
        v-else-if="canEdit"
        class="col-flex text-center cogs125"
        @click="showDetail = !showDetail"
      >
        <i v-if="showDetail === true" class="fa fa-toggle-on fa-fw c7" aria-hidden="true"></i>
        <i v-else class="fa fa-toggle-off fa-fw" aria-hidden="true"></i>
      </div>
    </div>

    <div class="row details" v-if="showDetail">
      <div class="col">
        <div v-if="item.range">
          <strong>
            <span v-if="item.type === 'Melee'">Reach</span>
            <span v-else>Range</span>
          </strong>
          {{item.range}}
        </div>

        <div v-if="item.damage && item.damage.critical">
          <strong>Critical</strong>
          <ez-modal-dice
            class="bold"
            slot="underline"
            :name="`${item.name} Critical`"
            :dice="`${item.damage.critical}+${damageBonus}`"
          >{{item.damage.critical}}<!--
            --><span v-if="damageBonus !== 0"><!--
            --><span v-if="damageBonus > -1">+</span>{{damageBonus}}</span>
          </ez-modal-dice>
        </div>

        <div v-if="item.summary">{{ item.summary }}</div>
      </div>

      <div class="col-flex" v-if="canEdit">
        <a :id="`actions-${item._id}`" @click="$emit('setId')" class="cogs125 modal-toggle">
          <i class="fa fa-cog fa-fw"></i>
        </a>
      </div>
    </div>

    <ez-modal v-if="showViewModal" @close="showViewModal = false" size="m-medium">
      <display :item="item"></display>
    </ez-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import EzModalDice from "@/components/shared/_VueEzModalDice.vue";
import PfActions from "@/components/shared/_PfActions.vue";
import Display from "./_Display.vue";
import modal from "@/mixins/vue-ez-modal";

export default {
  name: "sheet-actions-detail",
  mixins: [modal],
  components: {
    EzModalDice,
    Display,
    PfActions
  },
  props: ["section", "item", "attackBonus", "damageBonus", "ruleset"],
  data() {
    return {
      showViewModal: false,
      showDetail: false
    };
  },
  computed: {
    ...mapGetters({ canEdit: "characters/canEdit" }),
    name() {
      return this.item.name || "Action";
    },
    showToggle() {
      return this.item.range || this.item.damage.critical || this.item.summary;
    },
    toHitDisplay() {
      let display = "";
      if (["Savage Embers", "Savage Worlds"].includes(this.ruleset)) {
        display = this.attackBonus;
      } else {
        display =
          this.attackBonus > -1 ? `+${this.attackBonus}` : this.attackBonus;
      }
      return display;
    },
    toHitDice() {
      if (["Savage Embers", "Savage Worlds"].includes(this.ruleset)) {
        let toHitDice = this.toHitDisplay ? this.toHitDisplay : "1d4";
        return toHitDice;
      } else {
        return `1d20+${this.attackBonus}`;
      }
    },
    showToHit() {
      let show = false;

      if (["Savage Embers", "Savage Worlds"].includes(this.ruleset)) {
        show = this.item.attack.skill;
      } else {
        show =
          this.item.proficient ||
          this.item.attack.attribute ||
          Number.isFinite(parseInt(this.item.attack.misc, 10)) ||
          Number.isFinite(parseInt(this.item.attack.magic, 10));
      }

      return show;
    },
    showDamage() {
      return this.item.damage.dice || this.damageBonus;
    },
    showCritical() {
      return this.item.damage.critical;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/_global";

.magic {
  color: $magic;
  > a {
    color: lighten($magic, 10%);
    &:hover {
      color: darken($magic, 15%);
    }
  }
}
.small-left {
  margin-top: -0.25em;
}
.small-right {
  margin-bottom: -0.25em;
}
.bold {
  font-weight: 700;
}
.details {
  border-bottom: 3px solid $secondary;
  margin-bottom: 0.25em;
}
.cogs125 {
  cursor: pointer;
}

.action-group {
  position: relative;
  top: -0.2em;
}
.action-base {
  vertical-align: middle;
  line-height: 0.5rem;
}
.actions {
  margin-left: -0.4em;
  font-size: 1.4em;
  line-height: 0.5rem;
  vertical-align: middle;
  cursor: pointer;
}
</style>
